/**
 * Miscellaneous Domain Enums
 * Contains various domain-specific enums that don't fit in other categories
 */

import { COMPLEMENTARY_CHAPTER, MAIN_CHAPTER, SECONDARY_CHAPTER } from '../messages';

export enum chapterTypes {
  Main = 1,
  Secondary = 2,
  Complementary = 3,
}
export enum ChapterOrderLabels {
  mainChapterLabel = MAIN_CHAPTER,
  secondaryChapterLabel = SECONDARY_CHAPTER,
  complementaryChapterLabel = COMPLEMENTARY_CHAPTER,
}

export enum chapterOrigin {
  classroom = 'classroom',
}

export enum ValorationTypes {
  GoogleSheet = 'googlesheet',
  Classroom = 'classroom',
  Creci = 'creci',
}

export enum CommentTypes {
  Private = 'private',
  General = 'general',
  Additional = 'additional',
}

export enum TabsNames {
  ValorationTab = 'Mapa',
  AchievementTab = 'Logros',
  MyProfileTab = 'Mi perfil',
  PragmaticInformationTab = 'Información del pragmático',
  AssessmentSelfManagement = 'Gestión de crecimiento',
  GrowthRoute = 'Ruta de crecimiento',
}

export enum technicalWords {
  assessmentStartedOrSummarized = 'assessmentStartedOrSummarized',
  scoreEvent = 'scoreEvent',
  isResumeAssesment = 'isResumeAssesment',
  Technical = 'Technical',
  TeamTechnical = 'TeamTechnical',
  Team = 'Team',
  valoration = 'valoration',
  autoValoration = 'autoValoration',
  Shared = 'Shared',
  InvalidLink = 'invalidLink',
  TextArea = 'textArea',
  InputText = 'inputText',
  InputLink = 'inputLink',
  ID = 'id',
  Comment = 'Comentario',
  Competence = 'competence',
}

export enum QueryParams {
  Merge = 'merge',
  Chapter = 'chapter',
  Tab = 'tab',
  SpecialityId = 'specialityId',
  TechnologyId = 'technologyId',
}

export enum PragmaticTablePages {
  DefaultPage = 1,
  TotalPerPage = 25,
}

export enum TypeFilterDate {
  BEFORE = 1,
  AFTER = 2,
}

export enum ParentTypeId {
  Assessment = 1,
  Behavior = 2,
  NoteForValorator = 3,
  Activity = 4,
  GoalFromGoalGroup = 5,
}

export enum TypeMetadataId {
  ChapterId = 1,
  SpecialityId = 2,
  TechnologyId = 3,
  GoalId = 4,
}

export enum FieldComponent {
  FieldValue = 'fieldValue',
}

export enum KEY_NAMES {
  Enter = 'Enter',
}

export enum KeyNames {
  AccountName = 'account_name',
  ProjectName = 'project_name',
  LeaderMail = 'leader_mail',
  PragmaticRole = 'pragmatic_role_account',
  ExperienceTime = 'time_experience_role',
}

export enum ExtraDataFormKey {
  accountName = 'accountName',
  projectName = 'projectName',
  leaderEmail = 'leaderEmail',
  pragmaticRole = 'pragmaticRole',
  experienceTime = 'experienceTime',
}

export enum DurationUnit {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
}

export enum TimeUnitInMs {
  minutes = 60 * 1000,
  hours = 60 * 60 * 1000,
  days = 24 * 60 * 60 * 1000,
}

export enum PropertiesComponent {
  tabs = 'tabs',
  data = 'data',
}

export enum formObjectType {
  get = 'formObjectGet',
}

export enum responseStatus {
  success = 200,
}

export enum TYPE {
  string = 'string',
  number = 'number',
}

export type SiteUrl =
  | 'datadoghq.com'
  | 'us3.datadoghq.com'
  | 'us5.datadoghq.com'
  | 'datadoghq.eu'
  | 'ddog-gov.com'
  | 'ap1.datadoghq.com';
